import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';
import { SEGMENTED_ITEM, SEGMENTED_LIST } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

// Layout des réglages : sous-navigation (Entreprise / Équipe / Abonnement) puis
// Outlet. Pas de titre « Réglages » propre — les onglets tiennent lieu d'en-tête
// de section et chaque écran rend son propre titre (pas de doublon).
export const Route = createFileRoute('/_app/settings')({
  component: SettingsLayout,
});

const TABS = [
  { to: '/settings/organisation', label: 'Entreprise' },
  { to: '/settings/team', label: 'Équipe' },
  { to: '/settings/subscription', label: 'Abonnement' },
] as const;

function SettingsLayout() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  return (
    <div className="flex flex-col gap-6 p-6 lg:p-8">
      {/* UI-12 : la peau du segmented, la sémantique de la navigation. Le
          souligné d'avant faisait réapprendre au même niveau hiérarchique que
          les onglets du détail chantier. `role="tab"` n'a rien à faire ici :
          on change de route, on ne bascule pas une vue. */}
      <nav
        aria-label="Sections des réglages"
        className={cn(SEGMENTED_LIST, 'max-w-full overflow-x-auto')}
      >
        {TABS.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            aria-current={pathname.startsWith(tab.to) ? 'page' : undefined}
            className={SEGMENTED_ITEM}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
